import {useCallback} from 'react';
import {Drop} from '../../grpc_client/grips/protos/shared/drop';
import {useDropsSubscriptionsContext} from '../../pages/Drops/context/SubscriptionsProvider';
import {mediaMinDesktop} from '../../ui/constants/customMedia';
import {cdnImageUrl} from '../cdnImageUrl';
import {useMedia} from './useMedia';
import useTrackDropSubscription from './useTrackDropSubscription';

export default function useDropSubscribeClick({drop}: {drop?: Drop}) {
  const trackDropsSubscription = useTrackDropSubscription();
  const isDesktop = useMedia(
    {
      [mediaMinDesktop]: true,
    },
    false,
  );
  const {setModalData} = useDropsSubscriptionsContext();

  const onDropsSubscribeClick = useCallback(() => {
    let trackingSubscriptionLabel: 'all' | 'upcoming' = 'all';
    if (drop) {
      const backgroundImageUrl = isDesktop
        ? cdnImageUrl(drop.desktopImage)
        : cdnImageUrl(drop?.mobileWebImage);
      setModalData({
        backgroundImageUrl,
        headline: drop.headline,
        subline: drop.subline,
        isOpen: true,
        dropId: drop.id,
      });
      trackingSubscriptionLabel = 'upcoming';
    }
    trackDropsSubscription(trackingSubscriptionLabel);
  }, [drop, isDesktop, setModalData, trackDropsSubscription]);
  return onDropsSubscribeClick;
}
